<template>
  <v-dialog
    v-model="opened"
    content-class="date-edit"
    max-width="300"
    persistent
  >
    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#eee"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-date-picker
      v-model="input"
      class="elevation-0"
      full-width
      :locale="$i18n.locale"
      :max="max"
    />

    <div class="px-2 py-2">
      <v-btn
        color="warning"
        elevation="0"
        block
        :loading="loading"
        @click="onSave"
      >
        {{ $t('common.btns.edit') }}
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      default: '',
    },
    paramName: {
      type: String,
      default: 'date',
    },
  },
  data: () => ({
    loading: false,
    input: '',
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.input = '';
        this.loading = false;
        return;
      }

      [this.input] = this.date.split(' ');
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    max() {
      if (this.noMax) return null;
      return new Date().toISOString().substr(0, 10);
    },
  },
  methods: {
    onSave() {
      this.loading = true;
      this.$emit('save', { [this.paramName]: this.input });
    },
  },
};
</script>

<style lang="scss">
.date-edit {
  background-color: #fff;
}
</style>
